import {
  Button,
  CircularProgress,
  Grid
  // MenuItem,
  // Select,
  // Typography
} from '@mui/material'
import { Formik, Form, Field } from 'formik'
import { CheckboxWithLabel, TextField } from 'formik-mui'
import React, { Fragment } from 'react'
import { Zone } from '../../../interfaces'
import { zonaValidationSchema } from '../config/zonaConfig'
import { useStyles } from './styles'
import { WarehouseDDL } from '../../../components/Almacen'

const initialValues: Zone = {
  id: 0,
  zoneId: 0,
  warehouse: {
    warehouseId: 0,
    warehouseName: ''
  },
  zoneCode: '',
  zoneDescription: '',
  zoneName: '',
  active: true,
  warehouseId: -1,
  externalStorage: false
}

interface ZoneCreateModalProps {
  editingElement?: Zone
  handleSubitting: (zone: Zone) => void
}

const ZoneCreateModal: React.FC<ZoneCreateModalProps> = ({
  editingElement,
  handleSubitting
}) => {
  const classes = useStyles()

  return (
    <Fragment>
      <Formik
        initialValues={editingElement || initialValues}
        validationSchema={zonaValidationSchema}
        onSubmit={async (values, { setSubmitting }) => {
          try {
            handleSubitting(values) // Asegurar que se maneje como una Promise
          } catch (error) {
            console.error('Error en el envío:', error)
          } finally {
            setSubmitting(false) // Importante para restablecer el estado
          }
        }}
      >
        {({ isSubmitting, isValid, values, setFieldValue }) => (
          <Form autoComplete='off'>
            <Grid container direction='row' spacing={2}>
              <Grid item xs={12} md={6}>
                <Field
                  variant='outlined'
                  fullWidth
                  name='zoneName'
                  component={TextField}
                  label='Nombre Zona'
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <Field name='warehouseId' fullWidth>
                  {({ field: { value, onChange }, meta }: any) => (
                    <Fragment>
                      <WarehouseDDL
                        value={value}
                        onChange={onChange}
                        type='outlined'
                        fullWidth={true}
                      />
                      {meta.touched && meta.error && (
                        <div className={classes.error}>{meta.error}</div>
                      )}
                    </Fragment>
                  )}
                </Field>
              </Grid>

              <Grid item xs={12}>
                <Field
                  fullWidth
                  name='zoneDescription'
                  component={TextField}
                  label='Descripción Zona'
                  multiline
                  rows={3}
                  variant='outlined'
                />
              </Grid>
            </Grid>

            <Grid item xs={12} sm={2}>
              <Field
                name='active'
                component={CheckboxWithLabel}
                Label={{ label: 'Activo' }}
                type='checkbox'
                color='default'
                checked={values.active}
                onChange={async (e: any) => {
                  const { checked } = e.target
                  setFieldValue('active', checked)
                }}
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Field
                name='externalStorage'
                component={CheckboxWithLabel}
                Label={{ label: 'Externa' }}
                type='checkbox'
                color='default'
                checked={values.externalStorage}
                onChange={async (e: any) => {
                  const { checked } = e.target
                  setFieldValue('externalStorage', checked)
                }}
              />
            </Grid>

            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Button
                  disabled={isSubmitting || !isValid}
                  fullWidth
                  type='submit'
                  variant='contained'
                  color={isValid ? 'primary' : 'secondary'}
                  style={{
                    marginTop: '10px'
                  }}
                  startIcon={
                    isSubmitting ? (
                      <CircularProgress size='0.9rem' />
                    ) : undefined
                  }
                >
                  {isSubmitting ? '' : 'Guardar'}
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default ZoneCreateModal
